import { Component, OnInit, ViewChild } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute } from '@angular/router';
import { FileExportService } from 'src/app/common/file-export-service';
import { HtmlControlType } from 'src/app/enums/htmlControlType';
import { BookmarkData } from 'src/app/models/Bookmark';
import { FilePathCollection } from 'src/app/models/file/file-collection';
import { ExportFilter, FilterMappingService, FilterOutput } from 'src/app/models/filter-objects';
import { FilesDataExport } from 'src/app/models/forecast/topdown-adjustment.model';
import { LoadingIndicationService } from 'src/app/services/loading-indication.service';
import { NotificationService } from 'src/app/services/notification.service';
import { ShareDataService } from 'src/app/services/share-data.service';
import { WindowService } from 'src/app/services/window.service';
import { DevTooltipCustComponent, DropdowndSelectedValues } from 'src/app/widgets';
import { OperationType } from 'src/app/widgets/filters/miscellaneous/operation-type.enum';
import { QueryFilterParameter } from 'src/app/widgets/filters/models/query-filter-parameter.model';
import { HelpService } from '../../help/help.service';
import { SettingsService } from '../../settings/settings.service';
import { OverviewFilterInput, OverviewFiltersOutput } from '../../stock/stock.service';
import { TaskService } from '../../task/task.service';
import { EsoService, StockProjectionDto } from '../eso.service';
const EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
import * as FileSaver from 'file-saver';
import { DxChartComponent, DxDataGridComponent, DxRangeSelectorComponent } from 'devextreme-angular';
import { TableParameterService } from 'src/app/services/table-parameter-service';
import { DxDataGridOperator } from 'src/app/operators/dx-data-grid.operator';

@Component({
    selector: 'app-stock-projection',
    templateUrl: './stock-projection.component.html',
    styleUrls: ['./stock-projection.component.scss'],
    standalone: false
})
export class StockProjectionComponent implements OnInit {

	private readonly _componentTitle = "Stock Projection";
	public stockProjectionColumns: { columnName: string; caption: string }[] = [];
	public stockProjectionData: any[] = [];

	filterOptions: OverviewFiltersOutput = new OverviewFiltersOutput();
	filterList: OverviewFilterInput[] = [];
	htmlControlType = HtmlControlType;
	filters: QueryFilterParameter[] = [];
	public data: StockProjectionDto[] = [];
	public rangeSelectedData: StockProjectionDto[] = [];

	visualRange: any = {};

	@ViewChild("mainChart", { static: false })
	mainChart: DxChartComponent;

	@ViewChild("mainChartRangSelct", { static: false }) stockDevChartChartRangSelct: DxRangeSelectorComponent;
	@ViewChild('dataGrid', { static: false }) dataGrid: DxDataGridComponent;

	//Grid variables
	compactMode = false;
	gridColumns: { columnName: string; caption: string; dataType: string }[] = [];
	gridData: {
		IsDirty: boolean;
		ProductId: string;
		[key: string]: string | number | boolean;
	}[] = [];
	SettingDecimal: any;
	SettingsGroupByName() {
		this._settingsService.SettingsGroupByName("FcDeepDive", "EsoCurrencyField").subscribe(result => {
			this.SettingDecimal = result.table;
		});
	}

	// Key figures variables
	enableKeyFigure1 = false;
	enableKeyFigure2 = false;
	enableKeyFigure3 = false;
	keyFigure1Caption = '';
	keyFigure2Caption = '';
	keyFigure3Caption = '';
	actualLineColor = '';
	projectedLineColor = '';
	actualSimulatedLineColor = '';
	keyFigureOneLineColor = '';
	keyFigureTwoLineColor = '';
	keyFigureThreeLineColor = '';
	settings = [];

	//BookmarkData
	pageName: string = "StockProjection";
	dataFilter: BookmarkData;
	taskFilterData: any;
	IsTaskLoad: boolean = false;
	isFirstLoad = true;

	private initKeyFigures() {
		this._settingsService.getGeneralSettings().subscribe(res => {
			this.settings = res.settings;
			this.enableKeyFigure1 = this.settings.find(x => x.name === 'EnableStockKeyFigure1').value === 'Yes';
			this.enableKeyFigure2 = this.settings.find(x => x.name === 'EnableStockKeyFigure2').value === 'Yes';
			this.enableKeyFigure3 = this.settings.find(x => x.name === 'EnableStockKeyFigure3').value === 'Yes';

			this.keyFigure1Caption = this.settings.find(x => x.name === 'StockKeyFigure1Caption').value;
			this.keyFigure2Caption = this.settings.find(x => x.name === 'StockKeyFigure2Caption').value;
			this.keyFigure3Caption = this.settings.find(x => x.name === 'StockKeyFigure3Caption').value;

			this.actualLineColor = this.settings.find(x => x.name === 'Stock Actual Line Color').value;
			this.projectedLineColor = this.settings.find(x => x.name === 'Stock Projected Line Color').value;
			this.actualSimulatedLineColor = this.settings.find(x => x.name === 'Stock Actual Simulated Line Color').value;
			this.keyFigureOneLineColor = this.settings.find(x => x.name === 'Stock K Figure 1 Line Color').value;
			this.keyFigureTwoLineColor = this.settings.find(x => x.name === 'Stock K Figure 2 Line Color').value;
			this.keyFigureThreeLineColor = this.settings.find(x => x.name === 'Stock K Figure 3 Line Color').value;
		});
	}

	private initGridData() {
		this._esoService.getStockProjectionGridData(this.filterOptions.filters).subscribe(res => {
			this.gridColumns = [];
			if (res != null && res.gridData.columns != null) {
				for (var i = 0; i < res.gridData.columns.length; i++) {
					var dataTypeValue = "string";
					if (this.SettingDecimal != null && this.SettingDecimal.length > 0) {
						var itemFilter = this.SettingDecimal.find(x => x.name == res.gridData.columns[i].columnName);
						if (itemFilter != null) {
							dataTypeValue = "number";
						}
					}
					this.gridColumns.push({
						caption: res.gridData.columns[i].caption,
						columnName: res.gridData.columns[i].columnName,
						dataType: dataTypeValue
					})
				}
			}
			this.gridData = res.gridData.data;
		});
	}

	private initializeStockProjectionData() {
		const observable$ = this._esoService.getStockProjectionData(
			this.filterOptions.filters
		);

		const $this = this;

		return observable$.toPromise().then(
			(response) => {
				this.data = response;
				this.rangeSelectedData = response;
			}
		);
	}

	loadBookMarkFilterClick(data) {
		if (data != null && data != undefined && data.bookmarkId != null && data.bookmarkId != undefined) {
			this.filterOptions.filters = [];
			this.filterList.map(item => item.selectedValues = []);
			this.dataFilter = new BookmarkData();
			this.dataFilter.BookmarkId = data.bookmarkId;
			this.dataFilter.name = "Bokmk";
			this.dataFilter.pageName = this.pageName;
			this.loadBookMarkFilter();
		}
	}

	loadBookMarkFilter() {
		var filterData = Object.assign({}, this.dataFilter);
		filterData.name = "BokmkN";
		this.IsTaskLoad = true;
		this._taskServiceNew.LoadBookmarkData(filterData).subscribe(RData => {
			if (RData != null && RData.table != null && RData.table.length > 0) {
				this._taskServiceNew.LoadBookmarkFilter(this.dataFilter).subscribe(data => {
					this.taskFilterData = data;
					//default load with parameters
					this.filterOptions = new OverviewFiltersOutput();
					this.filterOptions.action = "Filter";
					this.filterOptions.settingGroupId = 1;
					this.filterOptions.filters = [];
					//loading filter data
					this.taskFilterData.forEach(element => {
						var filteItem: QueryFilterParameter = new QueryFilterParameter(element.fieldName, element.settingValue, 4);
						filteItem.fieldName = element.fieldName;
						filteItem.operation = 4;
						filteItem.value = element.settingValue;
						this.filterOptions.filters.push(filteItem);
					});
					this.IsTaskLoad = true;
					this._shareDataService.filterOptionOverview = this.filterOptions;
					this.getFilters();
				}
			);
			}
			else {
				this.filterOptions = new OverviewFiltersOutput();
				this.filterOptions.action = "Filter";
				this.filterOptions.filters = [];
				this.getFilters();
			}
		}
	);
	}

	private getFilters() {
		if (!this.filterOptions.filters) {
			this.filterOptions.filters = [];
		}
		this.ExportToExcelFilters = this.filterMappingService.mapQueryFilterOutputToFilterValue(this.filterOptions.filters);
		this._esoService.GetEsoStockProjectionFilters(this.filterOptions.filters).subscribe(
			(res) => {

				res.forEach((item) => {
					item.values = item.values ? item.values : [];
					this.filterOptions.filters = this.filterOptions.filters
						? this.filterOptions.filters
						: [];

					item.values = item.values.map((all) => ({ all }));
					item.selectedValues = this.filterOptions.filters
						.filter((filterItem) => filterItem.fieldName === item.selectionName)
						.map((filterItem) => filterItem.value);
					if (item.defaultFilterValue != null && item.defaultFilterValue != '' && item.values.length > 0 && this.isPageLoad) {
						item.selectedValues = [item.defaultFilterValue];
					}



				});
				this.filterList = res;

				if (this.isPageLoad) {
					this.isPageLoad = false;
					this.filterOptions.filters = [];
					this.filterList.forEach((item) => {
						if (item.selectedValues != null && item.selectedValues.length > 0) {
							item.selectedValues.forEach(element => {
								let filteItem: QueryFilterParameter = new QueryFilterParameter(
									item.selectionName,
									element,
									OperationType.Contains
								);
								this.filterOptions.filters.push(filteItem);
							});
						}
					});
				}

				this.initializeStockProjectionData();
				this.initGridData();
			}
		);
	}

	public onHelpButtonClicked(event, settingName: string) {
		this._helpService.openHelpPage(settingName);
	}
	isPageLoad: boolean = true;

	/* Export Option */
	IsExportEnable = false;
	getStockExportConfig() {
		this._settingsService.getGeneralSettings().subscribe(res => {
			this.IsExportEnable = res.settings.find(x => x.name === 'EnableStockDataExport').value === 'Yes';
		});
	}

	onToolbarPreparing(e: any) {
		e.toolbarOptions.items.unshift({
			location: "before",
			template: "gridActions",
		}, {
			location: 'before',
			template: 'heightButtonTemplate'
		});
	}

	goToDeepDive(data: any) {
		if (!data.ProductId) {
			return;
		}

		this._windowService.openInNewPage("/mrp/deepdive", {
			id: data.ProductId,
		});
	}


	isDropdown(type: HtmlControlType) {
		return type === HtmlControlType.Dropdown || type === HtmlControlType.List;
	}

	selectedItemsChanged(event: DropdowndSelectedValues) {
		this.filterList
			.filter((item) => item.selectionId === event.selectionId)
			.forEach((item) => (item.selectedValues = event.values));
	}

	onToggleColumnsMode() {
		this.compactMode = !this.compactMode;

		let currentState = this.dataGrid.instance.state();
		currentState.columns.forEach(col => {
			delete col.width;
		});

		this.dataGrid.instance.state(currentState);
	}

	setTextBoxFilterOptions(selectionId: number, el: any) {
		if (el.value) {
			this.filterList.forEach((item) => {
				if (item.selectionId === selectionId) {
					item.selectedValues = [el.value];
				}
			});
		}
	}

	onDataGridCellPrepared(e) {
		e.cellElement.style.padding = '5px';
	}

	public dxDataGridOperator: DxDataGridOperator = new DxDataGridOperator();

	public onDataGridContentReady(evt) {
		this.dxDataGridOperator.updateRowCount(evt.component);

		localStorage.setItem('grid-state-eso-stock', JSON.stringify(this.dataGrid.instance.state()));
	}

	applyFilters() {
		// Get setting to apply correct filter values
		var settings = [];
		this._settingsService.getGeneralSettings().subscribe(res => {
			settings = res.settings;

			let filters: QueryFilterParameter[] = [];

			if (this.filterOptions.filters) {
				this.filterList.forEach((item) => {
					if (item.selectedValues && item.selectedValues.length > 0) {
						item.selectedValues.forEach((el) => {
							let filter = new QueryFilterParameter(
								item.selectionName,
								el,
								OperationType.Equals
							);

							filters.push(filter);
						});
					}
				});
			}

			this.filterOptions.filters = filters;
			this._shareDataService.filterOptionOverview = this.filterOptions;
			this.getFilters();

		});
	}

	resetFilters() {
		this.filterOptions.filters = [];
		this.filterList.map((item) => (item.selectedValues = []));
		this._shareDataService.filterOptionOverview = this.filterOptions;
		this.isPageLoad = true;
		this.applyFilters();
	}

	legendClickHandler(e) {
		const series = e.target;
		if (series.isVisible()) {
			series.hide();
		} else {
			series.show();
		}
	};

	onRangeSelectorValueChanged(e) {
		const periodRange = e.value;
		const leftBoundary = periodRange[0];
		const rightBoundary = periodRange[1];

		this.rangeSelectedData = this.data.filter(x => +x.period >= +leftBoundary && +x.period <= +rightBoundary);
	}

	//adding customize setting with title, change title if need.
	customizeTooltip = (info: any) => {
		return DevTooltipCustComponent.customizeTooltip(info, "", "", "");
	  }

	  //tooltip
	  EnableTooltip = false;
	  ShowTooltip: boolean = false;
	  WebSettingsPivot() {
		this._fileExportService.WebSettingsPivot("actionpivotStockProjection").subscribe(result => {
		  console.log(result);
		  if (result != null && result.length > 0 && result[0].defaultSelectionTooltipStockProjection != null
			&& result[0].defaultSelectionTooltipStockProjection.toLowerCase() == "yes") {
			this.EnableTooltip = true;
		  }
		  if (result != null && result.length > 0 && result[0].enableDisableTooltipStockProjection != null
			&& result[0].enableDisableTooltipStockProjection.toLowerCase() == "yes") {
			this.ShowTooltip = true;
		  }

		}, err => {
		  console.log(err);
		});
	  }


	constructor(
		private _notificationService: NotificationService,
		private _titleService: Title,
		private _settingsService: SettingsService,
		private _esoService: EsoService,
		private _windowService: WindowService,
		private _helpService: HelpService,
		private _shareDataService: ShareDataService,
		private _routeMap: ActivatedRoute,
		private _taskServiceNew: TaskService,
		private _fileExportService: FileExportService,
		private tableParamService: TableParameterService
	) { }

	ngOnInit() {
		this._titleService.setTitle(this._componentTitle);


		this.dataFilter = new BookmarkData();
		this.dataFilter.BookmarkId = 0;
		this.dataFilter.name = "DefBokmk";
		this.dataFilter.pageName = this.pageName;
		this.loadBookMarkFilter();
		this.WebSettingsPivot();

		this.initKeyFigures();
		this.getStockExportConfig();
	}

	onResize() {
		if (this.mainChart && this.mainChart.instance) {
			this.mainChart.instance.refresh();
		}
		if (this.stockDevChartChartRangSelct && this.stockDevChartChartRangSelct.instance) {
			this.stockDevChartChartRangSelct.instance.render();
		}
	}
	filterMappingService = new FilterMappingService();
	ExportToExcelFilters: ExportFilter[] = [];

}
